import React, {  useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useJwt } from "react-jwt";
import axios from "axios";
import { API_BASE_URL } from "../utils/constants";
import Step1 from "../Components/Onboarding/Step1";
import Step2 from "../Components/Onboarding/Step2";
import Step3 from "../Components/Onboarding/Step3";
import Step4 from "../Components/Onboarding/Step4";
import moment from "moment";
import { GetListId } from "../utils/helpers";
const token ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJuYW1lIjoiWmVlc2hhbiIsImFnZSI6MjQsImlhdCI6MTY1MDAwMTc0MiwiZXhwIjoxNjUwMDAxODYyfQ.0vkpDWR4bk_Z-I_zyTmjnqS7tjI1izcv-95owLf_9hY";

function OnBoarding() {
  let history = useHistory();
  const [redirect, setRedirect] = useState(false);
  const [step, setStep] = useState(1);
  const [companyDetails, setCompanyDetails] = useState();
  const [data, setData] = useState();

  const [formData, setFormData] = useState({deposit_account: '', deposit_account_list_id:'' , item_income_account: '', 
  item_income_list_id:'', item_expense_account: '', item_expense_list_id:'', 
  createItem: 'non_inventory', item_income_inventory: '', item_income_inv_list_id: '', 
  item_cogs_inventory: '', item_cogs_inv_list_id: '', item_asset_inventory: '', item_asset_inv_list_id: '', syncType: 'both',
  inventoryStartDate: '', comp_id:''});
  const params = useParams();

  var User = JSON.parse(localStorage.getItem("User"));
  const { decodedToken, isExpired } = useJwt(User?.token);
  const tokenStatus = isExpired;

  useEffect(() => { 
    if (decodedToken) {
      apiCallToGetCompanySettings();
      apiCallToGetAccounts(decodedToken.comp_id);
    } else {
      console.log("Decoded token is not working in Onboarding");
    }
  }, [decodedToken]);

 

  function moveNextStep() {
    if (step < 4) {
    
      setStep((prev) => prev + 1);
    }
  }

  function moveBackStep() {
    if (step > 1) {
    
      setStep((prev) => prev - 1);
    }
  }

  const apiCallToGetAccounts = (companyId) => {
    if (decodedToken) {
      axios
        .get(
          API_BASE_URL +
            "/api/qbo/getAllAccounts?companyId=" + companyId
            
        )
        .then((res) => {
          const persons = res.data;
          setData(res.data);

        })
        .catch((err) => {
          console.log("err in catch of accounts list", err);
        });
    }
    else{
      console.log("no token found in for compId in onboarding");
    }
  };

  function renderSwitch(step) {
    switch (step) {
      case 1:
        return <Step1   data={data} onFinish={onFinish} formData={formData}/>;
      case 2:
        return (
          <Step2 moveBackStep={moveBackStep} moveNextStep={moveNextStep} data={data} onFinish={onFinish} formData={formData} />
        );
      case 3:
        return (
          <Step3 moveBackStep={moveBackStep} moveNextStep={moveNextStep} onFinish={onFinish} formData={formData}/>
        );
      case 4:
        return (
          <Step4 moveBackStep={moveBackStep} moveNextStep={moveNextStep} formData={formData}/>
        );
      default:
        return;
    }
  }

  const onFinish = (values) => {
 
    if(decodedToken){
      formData.comp_id = decodedToken.comp_id;
    }
    
    if(values.depositeAccount){
      formData.deposit_account = values.depositeAccount;
      var depositeAccountListId = GetListId(
        data.deposite,
        values.depositeAccount
      );
      formData.deposit_account_list_id = depositeAccountListId;
      
    }

    if(values.incomeAccount){
      formData.item_income_account = values.incomeAccount;
      var incomeAccountListId = GetListId(
        data.income,
        values.incomeAccount
      );
      formData.item_income_list_id = incomeAccountListId;
    }

    if(values.expenseAccount){
      formData.item_expense_account = values.expenseAccount;
      var expenseAccountListId = GetListId(
        data.expense,
        values.expenseAccount
      );
      formData.item_expense_list_id = expenseAccountListId;
    }
    if(values.createItem){
      formData.createItem = values.createItem;
    }
    if(values.inventoried_IncomeAccount){
      formData.item_income_inventory = values.inventoried_IncomeAccount;
      var income_inventoryAccountListId = GetListId(
        data.income,
        values.inventoried_IncomeAccount
      );
      formData.item_income_inv_list_id = income_inventoryAccountListId;
    }
    if(values.cogsAccount){
      formData.item_cogs_inventory = values.cogsAccount;
      var item_cogs_inventoryAccountListId = GetListId(
        data.cogs,
        values.cogsAccount
      );
      formData.item_cogs_inv_list_id = item_cogs_inventoryAccountListId;
    }
    if(values.assetAccount){
      formData.item_asset_inventory = values.assetAccount;
      var item_asset_inventoryAccountListId = GetListId(
        data.asset,
        values.assetAccount
      );
      formData.item_asset_inv_list_id = item_asset_inventoryAccountListId;
    }

    if(values.inventoryStartDate){
      formData.inventoryStartDate = moment.utc(values.inventoryStartDate).local();
    }
    if(values.syncType){
      formData.syncType = values.syncType;
    }

    moveNextStep();
  };

  async function apiCallToGetCompanySettings(companyId) {
    const companyDetails = await axios
      .get(API_BASE_URL + "/api/company/details?companyId=" + companyId)
      .then((res) => {
        return res.data.data;
      })
      .catch((err) => {
        console.log("err in catch of Company details in welcome", err);
      });
    setCompanyDetails(companyDetails);
  }

  return (
    <div
      className="flex items-center justify-center h-screen"
    >
      <div className="bg-white rounded-md shadow-xl w-full">
        <div className="flex flex-col items-center h-screen">
          {renderSwitch(step)}
        </div>
      </div>
    </div>
  );
}

export default OnBoarding;
